<script lang="ts">
  import { AssetPaths } from '../../assets/asset-store';
  import { LEADERBOARD } from '../../game/constants/hud';
  import type { LeaderboardRowView } from '../hud-state.svelte';

  const { rows, rank }: { rows: readonly LeaderboardRowView[]; rank: number } = $props();

  const { position, firstRowY, rowHeight, nameClip, nameX } = LEADERBOARD;

  // The div is the art, which hangs 20px left of the text origin these constants are measured from.
  const textX = -LEADERBOARD.imageOffsetX;
  const nameLeft = textX + nameX;
  const nameMaxWidth =
    nameClip.x + position.width * nameClip.widthFraction + nameClip.widthInset - nameX;
  const pointsLeft = textX + position.width * LEADERBOARD.scoreXFraction;

  const mine = $derived(rank > 0 && rank <= rows.length ? rank - 1 : -1);
</script>

<!--
  `Scoreboard.png`, top right. Rows are 17px apart from y=42, and names are clipped to the left
  column so a long one cannot run under the score.
-->
<div
  class="board"
  style:width="{position.width}px"
  style:height="{position.height}px"
  style:background-image="url({AssetPaths.ui('Scoreboard')})"
>
  <ol class="board__rows" style:top="{firstRowY}px">
    {#each rows as row, index (row.nameId)}
      <li
        class="board__row"
        class:board__row--mine={index === mine}
        style:top="{index * rowHeight}px"
        style:color={LEADERBOARD.teamColors[row.team === 1 ? 1 : 0]}
      >
        <span
          class="board__name"
          style:left="{nameLeft}px"
          style:max-width="{nameMaxWidth}px"
          style:font-size="{LEADERBOARD.nameFont}px">{row.name}</span
        >
        <span
          class="board__points"
          style:left="{pointsLeft}px"
          style:font-size="{LEADERBOARD.scoreFont}px">{row.points}</span
        >
      </li>
    {/each}
  </ol>

  {#if rank > 0}
    <span
      class="hud-text board__rank"
      style:top="{position.height}px"
      style:left="calc(50% + {textX / 2}px)"
      data-testid="rank">Rank: {rank}</span
    >
  {/if}
</div>

<style>
  .board {
    position: absolute;
    top: 0;
    right: 0;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .board__rows {
    position: absolute;
    left: 0;
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .board__row {
    position: absolute;
    width: 100%;
    height: 17px;
  }

  /* Inset to the plate's lit screen, measured off Scoreboard.png: it spans x 37..201 of the
     board's 230, so a band drawn across the row runs out over the frame. */
  .board__row--mine::before {
    position: absolute;
    top: 1px;
    right: 29px;
    bottom: 0;
    left: 37px;
    background: rgb(0 0 0 / 16%);
    content: '';
  }

  .board__name,
  .board__points {
    position: absolute;
    bottom: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .board__rank {
    transform: translate(-50%, -0.78em);
    font-size: 16px;
    color: #77eeff;
  }
</style>
